import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButton: {
    id: 'ui.button.cancel',
    defaultMessage: 'Cancel',
  },
  confirmButton: {
    id: 'ui.button.confirm',
    defaultMessage: 'Confirm',
  },
  pinnedColumnsTitle: {
    id: 'core.category.grid.config.pinned',
    defaultMessage: 'Pinned columns',
  },
  visibility: {
    id: 'core.category.grid.config.visibility',
    defaultMessage: 'Visibility',
  },
  columnName: {
    id: 'core.category.grid.config.columnName',
    defaultMessage: 'Column name',
  },
  editRule: {
    id: 'core.category.grid.config.rules.edit',
    defaultMessage: 'Edit rule',
  },
  copyOf: {
    id: 'core.category.grid.config.rules.copyOf',
    defaultMessage: 'Copy of',
  },
  preset: {
    id: 'core.category.grid.config.rules.preset',
    defaultMessage: 'Preset',
  },
  columns: {
    id: 'core.category.grid.config.tab.columns',
    defaultMessage: 'Columns',
  },
  design: {
    id: 'core.category.grid.config.tab.design',
    defaultMessage: 'Design',
  },
  other: {
    id: 'core.category.grid.config.tab.other',
    defaultMessage: 'Other',
  },
  field: {
    id: 'core.category.grid.config.table.field',
    defaultMessage: 'Field',
  },
  value: {
    id: 'core.category.grid.config.table.value',
    defaultMessage: 'Value',
  },
  color: {
    id: 'core.category.grid.config.table.color',
    defaultMessage: 'Text color',
  },
  backgroundColor: {
    id: 'core.category.grid.config.table.backgroundColor',
    defaultMessage: 'Background color',
  },
  locateNode: {
    id: 'core.category.grid.config.tab.other.locateNode',
    defaultMessage: 'Locate tree',
  },
  showDictionaryCondition: {
    id: 'core.category.grid.config.tab.other.showDictionaryCondition',
    defaultMessage: 'Filter in dictionary mode',
  },
  actions: {
    id: 'core.category.grid.config.tab.actions',
    defaultMessage: 'Actions',
  },
  rowsLimitInDataset: {
    id: 'core.category.grid.config.tab.other.rowsLimitInDataset',
    defaultMessage: 'Rows limit in dataset',
  },
  totals: {
    id: 'core.category.grid.config.totals',
    defaultMessage: 'Totals config',
  },
  caseInsensitive: {
    id: 'core.category.grid.config.tab.other.caseInsensitive',
    defaultMessage: 'Case insensitive',
  },
  recordView: {
    id: 'core.category.grid.config.tab.other.recordView',
    defaultMessage: 'View record',
  },
  hideZeroValues: {
    id: 'core.category.grid.config.tab.other.hideZeroValues',
    defaultMessage: "Don't display zero values",
  },
  useDefault: {
    id: 'core.category.grid.config.tab.actions.useDefault',
    defaultMessage: 'Use by default',
  },
  inToolbar: {
    id: 'core.category.grid.config.tab.actions.inToolbar',
    defaultMessage: 'Show in command bar',
  },
  inMenu: {
    id: 'core.category.grid.config.tab.actions.inMenu',
    defaultMessage: 'Show in menu',
  },
  showInToolbarHint: {
    id: 'core.category.grid.config.tab.actions.showInToolbarHint',
    defaultMessage: 'Show all commands in the command bar',
  },
  hideInToolbarHint: {
    id: 'core.category.grid.config.tab.actions.hideInToolbarHint',
    defaultMessage: 'Hide all commands in the command bar',
  },
  showInMenuHint: {
    id: 'core.category.grid.config.tab.actions.showInMenuHint',
    defaultMessage: 'Show all commands in the context menu',
  },
  hideInMenuHint: {
    id: 'core.category.grid.config.tab.actions.hideInMenuHint',
    defaultMessage: 'Hide all commands in the context menu',
  },
});
